import {RestService} from './_rest.service'
import {REST_API_END_POINTS} from './constants'
import {User} from "../api";

export class UserService extends RestService<User> {
    constructor(url) {
        if (url) {
            super(url)
        } else {
            super(REST_API_END_POINTS.USERS)
        }
    }

    getUserRights(uri: string, searchObj) {
        if (uri) {
            return this.instance.get(`${uri}rights/`, searchObj)
        } else {
            return this.instance.get(`${this.url}rights/`, searchObj)
        }
    }

    getUserDashboard(uri) {
        if (uri) {
            return this.instance.get(`${uri}dashboard/`)
        } else {
            return this.instance.get(`${this.url}dashboard/`)
        }
    }

    refreshGSXToken(token: string) {
        return this.instance.get(`${this.url}refresh_gsx_token/?gsx_token=${token}`)
    }

    restartServer() {
        return this.instance.get(`${this.url}restart_server/`)
    }

}
